'use client';
import { useEffect } from 'react';
import useShallowMemo from 'use-shallow-memo';
import isUndefined from '../utils/is-undefined.js';
import useDatadogRum from './use-datadog-rum.js';
const DEFAULT_USER = Object.freeze({});
export default function useUser(user = DEFAULT_USER) {
    const rum = useDatadogRum();
    const userMemo = useShallowMemo(user);
    useEffect(() => {
        if (Object.values(userMemo).every(isUndefined)) {
            return;
        }
        rum.setUser(userMemo);
        return () => {
            rum.clearUser();
        };
    }, [rum, userMemo]);
}
//# sourceMappingURL=use-user.js.map